<style scoped>

.pdf,
#pdf-obj,
#pdf-embed {
  width: 100% !important;
  height: 80vh !important;
}

</style>

<template>

<div class="pdf">
  <object id="pdf-obj" :data="stringSource" type="application/pdf">
    <embed id="pdf-embed" :src="stringSource" type="application/pdf" />
  </object>
</div>

</template>

<script>

export default {
  name: 'PDFItem',
  props: {
    media: {
      type: Object,
      required: true
    }
  },
  computed: {
    // String
    stringSource() {
      return this.media.content;
    }
  },
  mounted() {

  },
  methods: {

  },
}
</script>
